<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-spec-product modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>สเปคข้อมูลสินค้า</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <template v-if="!isShowNetworkError">
                            <div class="row" v-if="!isLoading && contentData">
                                <div class="col-sm-12 col-md-3">
                                    <div class="picture">
                                        <img src="/products/demo.png" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-9">
                                    <div class="product-data">
                                        <img :src="productData.brandLogo" class="brand" v-if="productData.brandLogo" />
                                        <h2>{{ productData.name }}</h2>
                                        <span v-if="productData.size">ขนาด {{ productData.size }}</span>
                                    </div>

                                    <div class="product-score">
                                        <div class="rating">
                                            <label>คะแนน</label>
                                            <b-icon icon="star-fill" v-for="(item, index) in contentData.rating.star" :key="index"></b-icon>
                                            <span>({{ contentData.rating.point }})</span>
                                        </div>
                                        <div class="score">
                                            <div class="item">
                                                <label>ความนุ่มนวล</label>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" 
                                                        role="progressbar"
                                                        :style="{ width: (contentData.score.soft * 20) + '%' }" 
                                                        :aria-valuenow="contentData.score.soft * 20" 
                                                        aria-valuemin="0"
                                                        aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <label>ความเงียบ</label>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" 
                                                        role="progressbar"
                                                        :style="{ width: (contentData.score.silence * 20) + '%' }" 
                                                        :aria-valuenow="contentData.score.silence * 20" 
                                                        aria-valuemin="0"
                                                        aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <label>ระยะเบรก</label>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" 
                                                        role="progressbar"
                                                        :style="{ width: (contentData.score.brake * 20) + '%' }" 
                                                        :aria-valuenow="contentData.score.brake * 20" 
                                                        aria-valuemin="0"
                                                        aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <label>ขับบนถนนเปียก</label>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" 
                                                        role="progressbar"
                                                        :style="{ width: (contentData.score.wet * 20) + '%' }" 
                                                        :aria-valuenow="contentData.score.wet * 20" 
                                                        aria-valuemin="0"
                                                        aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <label>ขับบนถนนแห้ง</label>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" 
                                                        role="progressbar"
                                                        :style="{ width: (contentData.score.dry * 20) + '%' }" 
                                                        :aria-valuenow="contentData.score.dry * 20" 
                                                        aria-valuemin="0"
                                                        aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="graph">
                                        <radar-chart
                                            v-if="chartData"
                                            :chartData="chartData.average" 
                                            :options="chartOption">
                                        </radar-chart>
                                    </div>

                                    <div class="user-test">
                                        <h4>คะแนนทดลองขับ</h4>

                                        <div class="row">
                                            <div class="col-12 col-sm-6">
                                                <div class="item">
                                                    <div class="review">
                                                        <div class="text">นักแข่ง</div>
                                                        <div class="point"><span>{{ contentData.review.racer.average }}</span>/5</div>
                                                    </div>
                                                    <div class="user">
                                                        <img src="@/assets/user-racer.png" />
                                                        <div class="chart">
                                                            <radar-chart
                                                                v-if="chartData"
                                                                :chartData="chartData.racer" 
                                                                :options="chartOptionReview">
                                                            </radar-chart>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="item">
                                                    <div class="review">
                                                        <div class="text">สื่อมวลชน</div>
                                                        <div class="point"><span>{{ contentData.review.media.average }}</span>/5</div>
                                                    </div>
                                                    <div class="user">
                                                        <img src="@/assets/user-journal.png" />
                                                        <div class="chart">
                                                            <radar-chart
                                                                v-if="chartData"
                                                                :chartData="chartData.media" 
                                                                :options="chartOptionReview">
                                                            </radar-chart>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="item">
                                                    <div class="review">
                                                        <div class="text">ผู้ชาย</div>
                                                        <div class="point"><span>{{ contentData.review.male.average }}</span>/5</div>
                                                    </div>
                                                    <div class="user">
                                                        <img src="@/assets/user-man.png" />
                                                        <div class="chart">
                                                            <radar-chart
                                                                v-if="chartData"
                                                                :chartData="chartData.male" 
                                                                :options="chartOptionReview">
                                                            </radar-chart>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="item">
                                                    <div class="review">
                                                        <div class="text">ผู้หญิง</div>
                                                        <div class="point"><span>{{ contentData.review.female.average }}</span>/5</div>
                                                    </div>
                                                    <div class="user">
                                                        <img src="@/assets/user-woman.png" />
                                                        <div class="chart">
                                                            <radar-chart
                                                                v-if="chartData"
                                                                :chartData="chartData.female" 
                                                                :options="chartOptionReview">
                                                            </radar-chart>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="spec-info">
                                        <h4>ข้อมูลสินค้า</h4>

                                        <div class="item">
                                            <label>หน้ายางกว้าง</label>
                                            <span>{{ contentData.spec.width }} ซม.</span>
                                        </div>
                                        <div class="item">
                                            <label>ความสูงของแก้มยาง (ซีรีย์)</label>
                                            <span>{{ contentData.spec.ratio }}%</span>
                                        </div>
                                        <div class="item">
                                            <label>เส้นผ่าศูนย์กลาง กระทะล้อ</label>
                                            <span>{{ contentData.spec.diameter }} นิ้ว</span>
                                        </div>
                                        <div class="item">
                                            <label>แก้มยางสูง</label>
                                            <span>{{ contentData.spec.sidewall }} ซม.</span>
                                        </div>
                                        <div class="item">
                                            <label>ความสูงของยางโดยรวม</label>
                                            <span>{{ contentData.spec.heightOverall }} ซม.</span>
                                        </div>
                                        <div class="item">
                                            <label>ความเร็วสูงสุด</label>
                                            <span>{{ contentData.spec.maxSpeed }} กม./ชม.</span>
                                        </div>
                                        <div class="item">
                                            <label>รับน้้าหนักต่อล้อ</label>
                                            <span>{{ contentData.spec.weight }} กก.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="no-data">
                                <b-icon icon="exclamation-diamond"></b-icon>
                                <span>ข้อมูลส่วนต้องใช้การเชื่อมต่ออินเทอร์เน็ต โปรดตรวจสอบการเชื่อมต่อของอุปกรณ์ที่ท่านใช้</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import RadarChart from '@/components/chart/Radar';
import Helper from '@/resources/Helper';

export default {
    components: {
        RadarChart
    },
    data() {
        return {
            isActive: false,
            isLoading: true,
            isShowNetworkError: false,
            contentData: null,
            chartData: null,
            chartName: 'คะแนนรีวิว',
            chartBackground: 'rgba(248, 239, 0, 0.1)',
            chartBorder: 'rgba(248, 239, 0, 0.5)',
            chartLabel: [
                'ความนุ่มนวล',	
                'ความเงียบ',	
                'ระยะเบรก',	
                'ขับบนถนนเปียก',	
                'ขับบนถนนแห้ง'
            ],
            chartOption: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                tooltips: { enable: false },
                scale: {
                    ticks: { display: false, max: 5, min: 0, maxTicksLimit: 6 },
                    gridLines: { color: 'rgba(255, 255, 255, 0.2)' },
                    angleLines: { color: 'rgba(255, 255, 255, 0.2)' }
                }
            },
            chartOptionReview: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                tooltips: { enable: false },
                scale: {
                    ticks: { display: false, max: 5, min: 0, maxTicksLimit: 6 },
                    gridLines: { color: 'rgba(255, 255, 255, 0.2)' },
                    angleLines: { color: 'rgba(255, 255, 255, 0.2)' },
                    pointLabels:{ fontSize: 0 }
                }
            }
        };
    },
    props: {
        isDisplay: Boolean,
        productData: Object
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.loadSpecData();
            }
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        async loadSpecData() {
            this.isLoading = true;
            this.isShowNetworkError = false;

            // Example API
            const result = await Helper.postAPI(Helper.getApiUrl(), '/api/master/product-spec', {});

            if (result) {
                this.contentData = result.data;

                this.setupChart();
            } else {
                this.isShowNetworkError = true;
            }

            this.isLoading = false;
        },
        setupChart() {
            this.chartData = {
                average: this.getChartObject(this.contentData.score),
                racer: this.getChartObject(this.contentData.review.racer),
                media: this.getChartObject(this.contentData.review.media),
                male: this.getChartObject(this.contentData.review.male),
                female: this.getChartObject(this.contentData.review.female),
            };
        },
        getChartObject(content) {
            return {
                labels: this.chartLabel,
                datasets: [{
                    label: this.chartName,
                    borderWidth: 1,
                    backgroundColor: this.chartBackground,
                    borderColor: this.chartBorder,
                    data: this.getChartData(content)
                }]
            };
        },
        getChartData(content) {
            const data = [];

            for (const property in content) {
                if (property !== 'average') {
                    data.push(content[property]);
                }
            }

            return data
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.modal-spec-product {
    max-width: 1000px;

    .no-data {
        padding: 100px 20px;
    }

    .picture {
        img {
            display: block;
            width: 100%;
            max-width: 200px;
            margin: 0 auto 20px;
        }
    }

    .product-data {
        .brand {
            width: auto;
            max-width: 100%;
            height: 25px;
            margin: 0 auto 10px;
        }

        h2 {
            font-size: 28px;
            font-weight: bold;
            font-style: italic;
            margin: 0;
        }

        span {
            font-size: 14px;
            opacity: 0.7;
        }
    }

    .product-score {
        .rating {
            padding: 10px 0 15px;
            border-bottom: 1px solid $textLightestColor;

            label {
                margin: 0 10px 0 0;
            }

            .bi {
                color: $mainColor; 
            }

            span {
                font-size: 15px;
                margin-left: 10px;
            }
        }

        .score {
            padding-top: 20px;

            label {
                font-size: 14px;
                opacity: 0.75;
            }
        }
    }

    .graph {
        margin-top: 30px;
    }

    .user-test {
        margin-top: 25px;
        padding: 15px;
        background: $textLightestColor;

        h4 {
            font-size: 18px;
            font-weight: bold;
            font-style: italic;
            padding-bottom: 10px;
            border-bottom: 1px solid $textLightColor;
        }

        .item {
            margin-top: 10px;

            .review {
                display: flex;
                font-size: 13px;
                margin-bottom: 5px;

                .text {
                    width: 80px;
                }

                .point {
                    span {
                        color: $mainColor;
                    }
                }
            }

            .user {
                display: flex;
                flex: 1;
                -ms-flex: 1 1 auto;
                flex-direction: row;
                background: $backgroundColor;

                img {
                    display: block;
                    width: 80px;
                }

                .chart {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    flex: 1;
                    -ms-flex: 1 1 auto;
                    height: 80px;
                }
            }
        }
    }

    .spec-info {
        margin-top: 25px;

        h4 {
            font-size: 18px;
            font-weight: bold;
            font-style: italic;
            padding-bottom: 10px;
            border-bottom: 1px solid $textLightColor;
        }
        
        .item {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            padding: 5px 0;
            border-bottom: 1px solid $textLightestColor;

            label {
                margin: 0;
                width: 180px;
                opacity: 0.6;
            }

            span {
                font-weight: bold;
            }
        }
    }
}
</style>